<template>
  <div class="qoder-tool-group">
    <qoder-message
      :all-items="group.items"
      :has-unfinished-session="hasUnfinishedSession"
      :is-tool-group-collapsible="isCollapsible"
      :message="head"
      @tool-use-toggle="$emit('tool-use-toggle', $event)"
    />
    <div
      v-if="isCollapsible"
      :aria-hidden="collapsed ? 'true' : 'false'"
      class="qoder-tool-group__collapsible"
      :class="{ 'is-collapsed': collapsed }"
    >
      <div class="qoder-tool-group__collapsible-inner">
        <qoder-message
          v-for="item in restItems"
          :key="item.id"
          :has-unfinished-session="hasUnfinishedSession"
          :message="item"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

import QoderMessage from './qoder-message/index.vue'

defineOptions({
  name: 'QoderToolGroup'
})

const props = defineProps({
  // 连续 tool_use 组成的分组：{ items: [...] }，首项为组首。
  group: {
    type: Object,
    required: true
  },
  hasUnfinishedSession: {
    type: Boolean,
    default: false
  }
})

defineEmits(['tool-use-toggle'])

// 组首始终展示，负责承载折叠箭头与点击。
const head = computed(() => props.group.items[0])

// 组内其余成员由统一的可折叠容器包裹，整组一起参与高度动画。
const restItems = computed(() => props.group.items.slice(1))

// 组内只有一条时没有可收起的内容。
const isCollapsible = computed(() => props.group.items.length > 1)

const collapsed = computed(() => Boolean(head.value.groupCollapsed))
</script>

<style lang="scss" scoped>
.qoder-tool-group {
  // 收起/展开：整个分组只跑一次行高过渡，避免各条消息各自收缩出现错位感。
  &__collapsible {
    display: grid;
    grid-template-rows: 1fr;
    transition: grid-template-rows 0.24s ease;

    &.is-collapsed {
      grid-template-rows: 0fr;
      pointer-events: none;
    }

    // grid 子项必须可裁剪，行高收缩时内容才会跟着收进去而不是把高度撑开。
    > * {
      min-width: 0;
      overflow: hidden;
    }
  }
}
</style>
